// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 3 hooks for backend/documents.

import { useBackend } from '../useBackend'

/** POST /api/documents/deleteDocument */
export function useDeleteDocument<T = any>() {
  return useBackend<T>('documents/deleteDocument')
}

/** POST /api/documents/getDocumentUrl */
export function useGetDocumentUrl<T = any>() {
  return useBackend<T>('documents/getDocumentUrl')
}

/** POST /api/documents/uploadDocument */
export function useUploadDocument<T = any>() {
  return useBackend<T>('documents/uploadDocument')
}
